<template>
    <div>
        <div class="ml-auto mb-3 text-right">
            <exportCSV
                class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                :data="exportData"
                :fields="exportFields"
                :header="exportHeaders"
                type="csv"
                :escapeCsv="false"
                :name="exportFileName">
                <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                <span class="mr-3">PDF</span>
                <i class="arrow-down fas fa-angle-down"></i> 
            </button> -->
        </div>
        <div class="row mb-3">
            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3">
                <date-range-picker
                    :minDate="minDate"
                    class="w-100"
                    ref="picker"
                    v-model="filterDate"
                    :opens="'right'"
                    :autoApply="true"
                    :showDropdowns="true"
                    :always-show-calendars="false"
                    :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                    @showCustomRange="showCustomRangeCalendars = true"
                    @update="filterByDate">
                </date-range-picker>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label
                                class="input-group-text border-right-0"
                                for="serviceCategory">
                                <i class="fas fa-store"></i>
                            </label>
                            <multiselect
                                :value="filterOutlet"
                                label="text"
                                track-by="id"
                                :options="outlets"
                                :searchable="false"
                                :show-labels="false"
                                openDirection="below"
                                @select="filterByOutlet">
                                <template
                                    slot="option"
                                    slot-scope="{ option }">{{ option.text }}</template>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="false" class="d-none d-lg-block d-xl-none col-lg-4"></div>
            <div class="col-sm-12 col-md-6 col-lg-auto col-xl-auto">
                <button class="btn btn-outline-primary btn-padding waves-effect waves-themed w-100" @click="openProjectionModalDefault">Set Projection</button>
            </div>
            <div v-if="false" class="col-sm-12 col-md-4 col-lg-auto col-xl-auto">
                <button class="btn btn-outline-primary btn-padding waves-effect waves-themed w-100" @click="openProjectionModalMonthly">Set Monthly Projection</button>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-auto col-xl-auto">
                <button class="btn btn-outline-primary btn-padding waves-effect waves-themed w-100" @click="openExpenditureModal">Add Expenses</button>
            </div>
        </div>

        <div>
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" v-for="c in $i18n.messages[$i18n.locale].tab.expensesTabs" :key="c.id">
                    <a :class="{ 'active': filterTab == c.id }" class="nav-link" role="tab" @click="filterByType(c.id)">{{ c.text }}</a>
                </li>
            </ul>
        </div>
        <br>

    </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'

export default {
    name: 'expensesFilter',
    props: {
        outlets: {
            type: Array,
            default(rawProps) {
                return []
            },
        },
        selectedOutlet: {
            type: Object,
            default(rawProps) {
                return {}
            },
        }
    },
    components: {
        DateRangePicker
    },
    data() {
        let startDate = moment().startOf('month').toDate();
        let endDate = moment().endOf('month').toDate()
        return {
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),
            
            filterSearch: "",
            filterDate: { startDate, endDate },
            filterOutlet: {},
            filterTab: 'summary',

            exportHeaders: [],
            exportFields: {},
            exportData: [],
            exportFileName: "",
        }
    },
    computed: {
    },
    watch: {
        "$i18n.locale"(val) {
            this.outlet = [{ id: "all", text: this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) }]
            this.outlet.push(...JSON.parse(this.$store.state.outlets))

            var b = Object.assign({}, this.selectedOutlet)
            this.selectedOutlet = this.outlet.filter(obj => obj.id == b.id)[0]
        },
        selectedOutlet(newItem) {
            this.filterOutlet = newItem
            this.setFilter()
        }
    },
    methods: {
        filterByOutlet(item) {
            this.filterOutlet = item
            this.setFilter()
        },
        filterByDate(date) {
            this.filterDate = date
            this.setFilter()
        },
        filterByType(tab) {
            this.filterTab = tab
            this.setFilter()
        },

        setFilter() {
            var data = {
                date: this.filterDate,
                search: this.filterSearch,
                outlet: this.filterOutlet,
                tab: this.filterTab,
            }
            this.$emit('filterOrder', data)
        },
        setExportData(item) {
            this.exportData = item.exportData
            this.exportFields = item.exportFields
            this.exportFileName = item.exportFileName
            this.exportHeaders = item.exportHeaders
        },

        openProjectionModalDefault() {
            this.$emit('openProjectionModalDefault')
        },
        openProjectionModalMonthly() {
            this.$emit('openProjectionModalMonthly')
        },
        openExpenditureModal() {
            this.$emit('openExpenditureModal')
        },
    },
    mounted() {
    }
}
</script>